import { render, staticRenderFns } from "./DepartmentAdd.vue?vue&type=template&id=07d34e3a&scoped=true"
import script from "./DepartmentAdd.vue?vue&type=script&lang=js"
export * from "./DepartmentAdd.vue?vue&type=script&lang=js"
import style0 from "./DepartmentAdd.vue?vue&type=style&index=0&id=07d34e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d34e3a",
  null
  
)

export default component.exports